import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/motion";

const TIERS = [
  { buy: 20, free: 10 },
  { buy: 30, free: 15 },
  { buy: 50, free: 25 },
  { buy: 100, free: 50 },
];

export default function SchemeBanner() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8" data-testid="scheme-banner-section">
      <Reveal>
        <div className="relative rounded-3xl overflow-hidden bg-emerald-900 shadow-2xl">
          <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-amber-400/10 pointer-events-none" />
          <div className="absolute -bottom-20 -left-10 w-64 h-64 rounded-full bg-emerald-700/40 pointer-events-none" />
          <div className="relative z-10 px-6 sm:px-12 py-12 text-center">
            <span className="inline-flex items-center gap-2 bg-amber-400 text-emerald-950 text-[11px] font-extrabold uppercase tracking-widest px-4 py-1.5 rounded-full">
              <Gift size={13} /> Trade Scheme Live
            </span>
            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mt-5 text-balance">
              Buy 10 Boxes, <span className="text-amber-400">Get 5 FREE</span>
            </h2>
            <p className="text-emerald-100/85 text-sm sm:text-base font-medium mt-3 max-w-xl mx-auto">
              Every bulk order of 10+ boxes earns free stock automatically — half your paid boxes, on us.
            </p>
            <div className="flex flex-wrap justify-center gap-2.5 mt-7">
              {TIERS.map((t, i) => (
                <motion.span
                  key={t.buy}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 + i * 0.08, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  className="bg-white/10 border border-white/20 backdrop-blur px-4 py-2 rounded-full font-mono-ed text-xs text-white"
                  data-testid={`scheme-tier-${t.buy}`}
                >
                  {t.buy} boxes <span className="text-amber-400 font-bold">+{t.free} FREE</span>
                </motion.span>
              ))}
            </div>
            <Link
              to="/shop"
              data-testid="scheme-banner-cta"
              className="group inline-flex items-center gap-2 mt-8 bg-amber-400 hover:bg-amber-300 text-emerald-950 px-9 py-4 rounded-xl font-extrabold text-sm shadow-lg transition-all duration-300 active:scale-95"
            >
              Order in Bulk Now <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <p className="font-mono-ed text-[10px] text-emerald-100/50 mt-4 uppercase tracking-wider">Auto-applied at checkout · Shown on your invoice · No coupon needed</p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
